//@flow
import type { TableColumnTypes } from 'common/entity/generic/EntityImportContainer/types';
import LineItemImportHelper from 'common/entity/lineItemMaster/LineItemImportHelper';

const LINE_ITEM_IMPORT_FORMAT: Array<TableColumnTypes> = [
    {
        titleKey: 'skuProperties.id',
        id: 'id',
        disabled: true,
        fixed: true,
        required: true,
        templateValue: 'masterImportTemplateValues.masterLineItem.id'
    },
    {
        titleKey: 'skuProperties.code',
        id: 'code',
        disabled: true,
        templateValue: 'masterImportTemplateValues.masterLineItem.code'
    },
    {
        titleKey: 'skuProperties.name',
        id: 'name',
        required: true,
        templateValue: 'masterImportTemplateValues.masterLineItem.name'
    },
    {
        titleKey: 'skuProperties.description',
        id: 'description',
        templateValue: 'masterImportTemplateValues.masterLineItem.description'
    },
    {
        titleKey: 'skuProperties.scanId',
        id: 'scanId',
        templateValue: 'masterImportTemplateValues.masterLineItem.scanId'
    },
    {
        titleKey: 'skuProperties.category',
        id: 'category',
        templateValue: 'masterImportTemplateValues.masterLineItem.category',
        validateCell: LineItemImportHelper.validateSalesCategory
    },
    {
        titleKey: 'skuProperties.instructions',
        id: 'instructions',
        templateValue: 'masterImportTemplateValues.masterLineItem.instructions',
        processCell: LineItemImportHelper.processNotes,
        serializeCell: LineItemImportHelper.serializeNotes
    },
    {
        titleKey: 'skuProperties.partLength',
        id: 'part.length',
        accessor: ['parts', 'dimensions', 'length'],
        templateValue: 'masterImportTemplateValues.masterLineItem.partLength',
        validateCell: LineItemImportHelper.validatePartDimensions,
        getModelFieldAccessor: LineItemImportHelper.getModelPartAccessor
    },
    {
        titleKey: 'skuProperties.partBreadth',
        id: 'part.breadth',
        accessor: ['parts', 'dimensions', 'breadth'],
        templateValue: 'masterImportTemplateValues.masterLineItem.partBreadth',
        validateCell: LineItemImportHelper.validatePartDimensions,
        getModelFieldAccessor: LineItemImportHelper.getModelPartAccessor
    },
    {
        titleKey: 'skuProperties.partHeight',
        id: 'part.height',
        accessor: ['parts', 'dimensions', 'height'],
        templateValue: 'masterImportTemplateValues.masterLineItem.partHeight',
        validateCell: LineItemImportHelper.validatePartDimensions,
        getModelFieldAccessor: LineItemImportHelper.getModelPartAccessor
    },
    {
        titleKey: 'skuProperties.partVolume',
        id: 'part.volume',
        required: true,
        accessor: ['parts', 'volume'],
        templateValue: 'masterImportTemplateValues.masterLineItem.partVolume',
        validateCell: LineItemImportHelper.validatePartVolume,
        getModelFieldAccessor: LineItemImportHelper.getModelPartAccessor,
        processCell: LineItemImportHelper.processPartVolume,
        serializeCell: LineItemImportHelper.serializePartVolume
    },
    {
        titleKey: 'skuProperties.partWeight',
        id: 'part.weight',
        accessor: ['parts', 'weight'],
        templateValue: 'masterImportTemplateValues.masterLineItem.partWeight',
        validateCell: LineItemImportHelper.validatePartWeight,
        getModelFieldAccessor: LineItemImportHelper.getModelPartAccessor
    },
    {
        titleKey: 'skuProperties.otherPartsLength',
        id: 'otherParts.length',
        accessor: ['otherParts', 'dimensions', 'length'],
        templateValue:
            'masterImportTemplateValues.masterLineItem.otherPartsLength',
        processCell: LineItemImportHelper.processOtherParts,
        validateCell: LineItemImportHelper.validateOtherPartsDimensions,
        serializeCell: LineItemImportHelper.serializeOtherParts,
        getModelFieldAccessor: LineItemImportHelper.getModelOtherPartsAccessor
    },
    {
        titleKey: 'skuProperties.otherPartsBreadth',
        id: 'otherParts.breadth',
        accessor: ['otherParts', 'dimensions', 'breadth'],
        templateValue:
            'masterImportTemplateValues.masterLineItem.otherPartsBreadth',
        processCell: LineItemImportHelper.processOtherParts,
        validateCell: LineItemImportHelper.validateOtherPartsDimensions,
        serializeCell: LineItemImportHelper.serializeOtherParts,
        getModelFieldAccessor: LineItemImportHelper.getModelOtherPartsAccessor
    },
    {
        titleKey: 'skuProperties.otherPartsHeight',
        id: 'otherParts.height',
        accessor: ['otherParts', 'dimensions', 'height'],
        templateValue:
            'masterImportTemplateValues.masterLineItem.otherPartsHeight',
        processCell: LineItemImportHelper.processOtherParts,
        validateCell: LineItemImportHelper.validateOtherPartsDimensions,
        serializeCell: LineItemImportHelper.serializeOtherParts,
        getModelFieldAccessor: LineItemImportHelper.getModelOtherPartsAccessor
    },
    {
        titleKey: 'skuProperties.otherPartsVolume',
        id: 'otherParts.volume',
        accessor: ['otherParts', 'volume', 'value'],
        templateValue:
            'masterImportTemplateValues.masterLineItem.otherPartsVolume',
        processCell: LineItemImportHelper.processOtherParts,
        validateCell: LineItemImportHelper.validateOtherPartsVolumes,
        serializeCell: LineItemImportHelper.serializeOtherParts,
        getModelFieldAccessor: LineItemImportHelper.getModelOtherPartsAccessor
    },
    {
        titleKey: 'skuProperties.otherPartsWeight',
        id: 'otherParts.weight',
        accessor: ['otherParts', 'weight'],
        templateValue:
            'masterImportTemplateValues.masterLineItem.otherPartsWeight',
        processCell: LineItemImportHelper.processOtherParts,
        validateCell: LineItemImportHelper.validateOtherPartsWeights,
        serializeCell: LineItemImportHelper.serializeOtherParts,
        getModelFieldAccessor: LineItemImportHelper.getModelOtherPartsAccessor
    },
    {
        titleKey: 'skuProperties.transactionDuration',
        id: 'transactionDuration',
        templateValue:
            'masterImportTemplateValues.masterLineItem.transactionDuration',
        processCell: LineItemImportHelper.processMinutesToSeconds
    },
    {
        titleKey: 'skuProperties.isCrateable',
        id: 'shouldCrate',
        templateValue: 'masterImportTemplateValues.masterLineItem.booleanValue',
        validateCell: LineItemImportHelper.getBooleanValidator(),
        processCell: LineItemImportHelper.getBooleanProcessor()
    },
    {
        titleKey: 'skuProperties.boxQuantity',
        id: 'boxQuantity',
        accessor: ['carton', 'capacity'],
        templateValue: 'masterImportTemplateValues.masterLineItem.boxQuantity',
        serializeCell: LineItemImportHelper.serializeBoxQuanity,
        getModelFieldAccessor: LineItemImportHelper.getCartonAccessor
    },
    {
        titleKey: 'skuProperties.boxLength',
        id: 'carton.length',
        accessor: ['carton', 'dimensions', 'length'],
        templateValue: 'masterImportTemplateValues.masterLineItem.boxLength',
        validateCell: LineItemImportHelper.validateCartonDimensions,
        serializeCell: LineItemImportHelper.serializeCartonLength,
        getModelFieldAccessor: LineItemImportHelper.getCartonDimensionsAccessor
    },
    {
        titleKey: 'skuProperties.boxBreadth',
        id: 'carton.breadth',
        accessor: ['carton', 'dimensions', 'breadth'],
        templateValue: 'masterImportTemplateValues.masterLineItem.boxBreadth',
        validateCell: LineItemImportHelper.validateCartonDimensions,
        serializeCell: LineItemImportHelper.serializeCartonBredth,
        getModelFieldAccessor: LineItemImportHelper.getCartonDimensionsAccessor
    },
    {
        titleKey: 'skuProperties.boxHeight',
        id: 'carton.height',
        accessor: ['carton', 'dimensions', 'height'],
        templateValue: 'masterImportTemplateValues.masterLineItem.boxHeight',
        validateCell: LineItemImportHelper.validateCartonDimensions,
        serializeCell: LineItemImportHelper.serializeCartonHeight,
        getModelFieldAccessor: LineItemImportHelper.getCartonDimensionsAccessor
    },
    {
        titleKey: 'skuProperties.boxVolume',
        id: 'carton.volume',
        accessor: ['carton', 'volume'],
        templateValue: 'masterImportTemplateValues.masterLineItem.boxVolume',
        validateCell: LineItemImportHelper.validateCartonVolume,
        serializeCell: LineItemImportHelper.serializeCartonVolume,
        processCell: LineItemImportHelper.processCartonVolume,
        getModelFieldAccessor: LineItemImportHelper.getCartonAccessor
    },
    {
        titleKey: 'skuProperties.boxWeight',
        id: 'carton.weight',
        accessor: ['carton', 'weight'],
        templateValue: 'masterImportTemplateValues.masterLineItem.boxWeight',
        validateCell: LineItemImportHelper.validateCartonWeight,
        serializeCell: LineItemImportHelper.serializeCartonWeight,
        getModelFieldAccessor: LineItemImportHelper.getCartonAccessor
    },
    {
        titleKey: 'skuProperties.skillId',
        id: 'skills',
        templateValue: 'masterImportTemplateValues.masterLineItem.skills',
        processCell: LineItemImportHelper.processSkills,
        validateCell: LineItemImportHelper.validateSkills,
        serializeCell: LineItemImportHelper.serializeSkills
    },
    {
        titleKey: 'skuProperties.manufacturingLocations',
        id: 'locationIds',
        templateValue: 'masterImportTemplateValues.masterLineItem.locationIds',
        processCell: LineItemImportHelper.processLocationIds,
        getIdForAsyncValidation: locationId => {
            return locationId.locationId;
        },
        validateCellAsync: ({
            entity,
            header,
            onSuccess,
            onFailure,
            validateLocationIds,
            clientId,
            t
        }) => {
            LineItemImportHelper.validateEntityIdAsync({
                validator: validateLocationIds,
                clientId,
                onSuccess,
                onFailure,
                entity,
                header,
                t
            });
        },
        serializeCell: LineItemImportHelper.serializeLocations
    },
    {
        titleKey: 'skuProperties.minTemperature',
        id: 'minTemperature',
        accessor: ['temperatureThreshold', 'lowerThreshold'],
        templateValue:
            'masterImportTemplateValues.masterLineItem.minTemperature'
    },
    {
        titleKey: 'skuProperties.maxTemperature',
        id: 'maxTemperature',
        accessor: ['temperatureThreshold', 'higherThreshold'],
        templateValue:
            'masterImportTemplateValues.masterLineItem.maxTemperature'
    },
    {
        titleKey: 'skuProperties.tempType',
        id: 'tempType',
        accessor: ['temperatureThreshold', 'temperatureType'],
        templateValue: 'masterImportTemplateValues.masterLineItem.tempType',
        processCell: LineItemImportHelper.processUpperCaseId
    }
];

export default LINE_ITEM_IMPORT_FORMAT;
